import { Box, Skeleton } from '@mui/material';

// Mirrors NavigationTree's loading skeleton rhythm plus a content placeholder.
export function HomeProductsSkeleton() {
  return (
    <Box sx={{ display: 'flex', gap: 2, p: 2, height: '100%' }}>
      <Box sx={{ width: 240, flexShrink: 0 }}>
        {Array.from({ length: 6 }).map((_, index) => (
          <Skeleton key={index} height={44} sx={{ mb: 1, borderRadius: 1 }} />
        ))}
      </Box>
      <Skeleton
        variant="rounded"
        sx={{ flex: 1, minHeight: 480, borderRadius: 2 }}
      />
    </Box>
  );
}
